import type { SVGProps } from "react";

export function CoworkingSpaceIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4225 1C9.24928 1 9.24928 1.5828 9.24928 2.1656V7.9936C9.24928 8.5764 9.7789 9.1592 10.4225 9.1592C10.4225 9.1592 13.1443 9.14149 13.1437 9.1592L12.6 11.3447H1.45826C1.02716 11.3447 1 11.3906 1 12.1202C1 13.1901 1.30551 13.5272 2.27689 13.5293L2.75169 13.5302L2.72559 13.6782C2.43856 15.3036 1.45562 21.9595 1.47944 22.117C1.6444 23.2098 3.33872 23.3144 3.63349 22.2498C3.66822 22.1244 3.99092 20.1112 4.35063 17.776L5.00459 13.5302H18.9935L19.6485 17.776C20.0087 20.1112 20.3246 22.1094 20.3503 22.2163C20.6157 23.3182 22.3499 23.235 22.5193 22.1123C22.5424 21.9594 21.5529 15.2657 21.2725 13.6782L21.2464 13.5302L21.7211 13.5293C22.6926 13.5272 22.9981 13.1901 22.9981 12.1202C22.9981 11.2815 23.1101 11.3447 21.6232 11.3447H20.8368L20.8358 11.0146C20.8358 10.443 20.6203 10.2436 19.5417 10.2452C18.4769 10.2468 18.2666 10.4734 18.2666 11.0245V11.3447H17.619L17.0872 9.1592C17.0827 9.14096 19.8084 9.1592 19.8084 9.1592C20.5051 9.1592 20.9816 8.5764 20.9816 7.9936V2.1656C20.9816 1.5828 20.5935 1 19.8084 1H10.4225Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.90054 14.0975C5.56122 15.254 5.28174 16.2812 5.28174 16.992C5.50201 17.1991 5.84599 17.3578 6.22756 17.4746C6.576 17.6499 6.60551 17.3458 6.00986 19.7181C5.46847 21.8742 5.45029 21.995 5.61419 22.3457C6.0914 23.3669 7.44537 23.1105 7.72061 21.9469L7.80379 21.5957L8.64664 17.9587C8.64664 17.9587 8.86705 17.9929 9.35539 18.0009C9.85817 17.9924 10.0599 17.9586 10.0599 17.9586L10.9045 21.5938L10.9843 21.9231C11.2428 22.991 12.2898 23.3548 12.9368 22.6015C13.3068 22.1707 13.3019 22.1115 12.701 19.718C12.1053 17.3457 12.1348 17.6498 12.4832 17.4746C12.8415 17.2945 13.2088 17.1991 13.4291 16.992C13.4291 16.3522 13.1717 15.3525 12.8362 14.0975"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.64828 10.0781C9.09509 9.68949 9.58536 9.70546 11.083 10.0781C11.2696 10.1245 11.4251 10.5628 11.4251 10.5628H7.30615C7.30615 10.5628 7.46213 10.1281 7.64828 10.0781Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeMiterlimit="2"
        strokeLinecap="square"
      />
    </svg>
  );
}
